<template>
  <a-table :data-source="data" :columns="columns" :loading="loading" :pagination="pagination"
           :style="{background:'url('+imagePath+')'}">
    <div
      slot="filterDropdown"
      slot-scope="{ setSelectedKeys, selectedKeys, confirm,clearFilters, column }"
      style="padding: 8px;"
    >
      <a-input
        v-ant-ref="c => (searchInput = c)"
        :placeholder="`搜索 ${column.title}`"
        :value="selectedKeys[0]"
        style="width: 188px; margin-bottom: 8px; display: block;"
        @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
        @pressEnter="() => {clearFilters();handleSearch(selectedKeys,confirm, column.dataIndex);}"
      />
      <a-button
        type="primary"
        icon="search"
        size="small"
        style="width: 90px; margin-right: 8px"
        @click="() => {clearFilters();handleSearch(selectedKeys,confirm, column.dataIndex);}"
      >
        搜索
      </a-button>
      <a-button size="small" style="width: 90px" @click="() => {clearFilters();handleReset();}">
        重置
      </a-button>
    </div>
    <a-icon
      slot="filterIcon"
      slot-scope="filtered"
      type="search"
      :style="{ color: filtered ? '#108ee9' : undefined }"
    />
    <template slot="customRender" slot-scope="text, record, index, column">
      <template>
        {{ text }}
      </template>
    </template>
  </a-table>
</template>

<script>
import axios from 'axios';

const url = "http://www.tcnanhua.com:5555/t-stk-inventory/selectTStkInventory";
export default {
  name: "stock",
  data() {
    return {
      imagePath: require('../assets/bj7.jpg'),
      data: [],
      searchInput: null,
      pagination: {},
      loading: false,
      columns: [
        {
          title: '物料代码',
          dataIndex: 'fnumber',
          key: 'fnumber',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'customRender',
          },
          onFilter: (value, record) =>
            record.fnumber
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: visible => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              }, 0);
            }
          },
        },
        {
          title: '物料名称',
          dataIndex: 'fname',
          key: 'fname',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'customRender',
          },
          onFilter: (value, record) =>
            record.fname
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: visible => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              });
            }
          },
        },
        // {
        //   title: '组织',
        //   dataIndex: 'fownername',
        //   key: 'fownername',
        //   scopedSlots: {
        //     filterDropdown: 'filterDropdown',
        //     filterIcon: 'filterIcon',
        //     customRender: 'customRender',
        //   },
        //   onFilter: (value, record) =>
        //     record.fownername
        //       .toString()
        //       .toLowerCase()
        //       .includes(value.toLowerCase()),
        //   onFilterDropdownVisibleChange: visible => {
        //     if (visible) {
        //       setTimeout(() => {
        //         this.searchInput.focus();
        //       });
        //     }
        //   },
        // },
        // {
        //   title: '仓库名字',
        //   dataIndex: 'fstockname',
        //   key: 'fstockname',
        //   scopedSlots: {
        //     filterDropdown: 'filterDropdown',
        //     filterIcon: 'filterIcon',
        //     customRender: 'customRender',
        //   },
        //   onFilter: (value, record) =>
        //     record.fstockname
        //       .toString()
        //       .toLowerCase()
        //       .includes(value.toLowerCase()),
        //   onFilterDropdownVisibleChange: visible => {
        //     if (visible) {
        //       setTimeout(() => {
        //         this.searchInput.focus();
        //       });
        //     }
        //   },
        // },
        {
          title: '仓位名称',
          dataIndex: 'fstocklocno',
          key: 'fstocklocno',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'customRender',
          },
          onFilter: (value, record) =>
            record.fstocklocno
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: visible => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              });
            }
          },
        },
        {
          title: '即时库存',
          dataIndex: 'fqty',
          key: 'fqty',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'customRender',
          },
          onFilter: (value, record) =>
            record.fqty
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: visible => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              });
            }
          },
        },
        {
          title: '可用库存',
          dataIndex: 'favgqty',
          key: 'favgqty',
          scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon',
            customRender: 'customRender',
          },
          onFilter: (value, record) =>
            record.favgqty
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: visible => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              });
            }
          },
        },
      ],
    };
  },
  mounted() {
    this.handleReset()
  },
  methods: {
    handleSearch(selectedKeys, confirm, dataIndex) {
      confirm();
      this.loading = true;
      axios.get(url + '?' + dataIndex + "=" + selectedKeys[0])
        .then((res) => {
          const pagination = {...this.pagination};
          pagination.total = res.data.data.length;
          this.loading = false;
          this.data = res.data.data;
          this.pagination = pagination;
        })
    },
    handleReset() {
      this.loading = true;
      axios.get(url)
        .then((res) => {
          const pagination = {...this.pagination};
          pagination.total = res.data.data.length;
          this.loading = false;
          this.data = res.data.data;
          this.pagination = pagination;
        })
    },
  },

};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Stock.vue